import React, { useEffect, useState } from 'react'
import { loadSettings, putUpdateSetting } from '../../store/Actions/ActionSetting';
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';
import SectionTopOfTable from '../general/general-component/section-top-of-table/SectionTopOfTable';
import Notifications from '../../pages/settings/NotificationSettings';
import { UsePermissions, hasPermissions } from '../general/general-component/abstruct-component/UsePermissions';
import CheckPermissions from '../general/general-component/check-permissions';
import CheckLazyLoader from '../general/general-component/check-lazy-loader';


function NotificationsPage() {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const notifications = hasPermissions([{ name: "notifications" }], permissionss)
    const [activeSection, setActiveSection] = useState('notifications');
    const { translate } = AbstructLang();
    const [isLoading, setLoading] = useState(false);
    const { dispatch, langLocal, navigate } = AbstructVar();
    const { settings, loadingSettings } = useSelectorCustom();

    const handleSectionClick = (sectionId) => {
        setActiveSection(sectionId);
    };

    const handleEdit = (settingName, value) => {
        dispatch(putUpdateSetting(settingName, value, setLoading));
    };

    useEffect(() => {
        dispatch(loadSettings());
    }, []);

    return (
        <CheckLazyLoader>
            <CheckPermissions array={notifications} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className='div_table margin_main shadow_main' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('Notifications')} />
                        <div className='all_setting'>
                            <div className='head_with_title'>
                                <span className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} onClick={() => handleSectionClick('notifications')}>{translate('Notifications')}</span>
                            </div>
                            {activeSection === 'notifications' && (
                                <Notifications
                                    translate={translate}
                                    settings={settings}
                                    loadingSettings={loadingSettings}
                                    handleEdit={handleEdit}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </CheckPermissions>

        </CheckLazyLoader>
    );
}

export default NotificationsPage